import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

const firebaseConfig = {
    apiKey: "AIzaSyAY0C493RiBUo7EaZuLGu7n3j0TuTgEV9c",
    authDomain: "disney-clone-b9f8f.firebaseapp.com",
    projectId: "disney-clone-b9f8f",
    storageBucket: "disney-clone-b9f8f.appspot.com",
    messagingSenderId: "1084277497227",
    appId: "1:1084277497227:web:39126f248daa998a30a38e",
    measurementId: "G-N4C62KP9TG"
  };

  const firebaseApp=firebase.initializeApp(firebaseConfig);
  const db=firebaseApp.firestore();
  const auth=firebase.auth();
  const provider=new firebase.auth.GoogleAuthProvider();
  const storage=firebase.storage();

  export {auth,provider,storage};
  export default db;